import { jsx as _jsx } from "react/jsx-runtime";
import s from './Spinner.module.css';
export function Spinner({ size = 14 }) {
    return (_jsx("span", { role: "status", "aria-label": "Loading", className: s.spin, style: { width: size, height: size } }));
}
